var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5483 6C13.2253 8.41537 15.1176 10.3231 17.5483 11M14 4.33966L4.15531 13.9742C3.8356 14.2939 3.53188 14.9172 3.46794 15.3647L3.02035 18.5293C2.86049 19.68 3.65976 20.4791 4.81071 20.3193L7.97575 19.8718C8.42335 19.8079 9.04677 19.5042 9.36648 19.1845L19.2112 9.54993C20.6339 8.12748 21.3213 6.46534 19.2112 4.35564C17.1012 2.22996 15.4387 2.90123 14 4.33966Z",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.9d04e46dfb992d5a288e35d10a032222.svg";
export { ForwardRef as ReactComponent };